import { RootState } from 'store';

export const selectAll = ({ dashboard }: RootState) => dashboard.notifications.rows;
